<template>
  <div
    :class="[
      'container quote mb-64 mb-lg-80',
      { 'quote--second': secondQuoteVariant },
      { 'mt-56 mt-lg-72': !secondQuoteVariant },
    ]"
  >
    <div class="row f-flex justify-content-center">
      <div
        :class="[
          'column position-relative ',
          { 'col-md-7': secondQuoteVariant },
          { 'col-md-9': !secondQuoteVariant },
        ]"
      >
        <p class="text-quote mb-0 mb-lg-16">
          {{ quote.quote }}
        </p>

        <p
          :class="[
            'quote__author mt-24',
            {
              'd-none': !secondQuoteVariant,
            },
          ]"
        >
          {{ quote.author }}
        </p>
      </div>

      <div
        :class="[
          'column col-sm-9',
          {
            'd-none': secondQuoteVariant,
          },
        ]"
      >
        <p class="quote__author mb-24 mt-24">{{ quote.author }}</p>
        <div v-if="quote.rating" class="d-flex justify-content-center mb-24">
          <StarsRating :rating="quote.rating" />
        </div>
      </div>

      <div
        v-if="quote.authorPhoto"
        :class="[
          'column ',
          { 'col-md-9': !secondQuoteVariant },
          { 'col-md-3 col-xl-2': secondQuoteVariant },
        ]"
      >
        <BaseLazyImage
          :src="`${quote.authorPhoto}?width=288&height=304&fit=scale-down`"
          :width="144"
          :height="152"
          fluid
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseLazyImage from '~/components/BaseLazyImage'
import StarsRating from '~/components/reviews/StarsRating'

export default {
  components: {
    BaseLazyImage,
    StarsRating,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
    secondQuoteVariant: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.column {
  text-align: center;
}

p {
  position: relative;
  z-index: 2;
}

img {
  width: 144px;
  height: 152px;
  clip-path: path(
    'M125.944 46.3001C136.975 64.9944 145.351 80.774 143.819 97.1566C142.185 113.539 130.745 130.424 113.381 140.978C95.9145 151.43 72.4219 155.652 50.8701 148.315C29.3183 141.078 9.7071 122.283 2.86362 98.8652C-4.08199 75.4471 1.84221 47.4057 18.0827 27.6059C34.221 7.70549 60.7778 -3.8528 80.8997 1.17254C101.022 6.09738 114.811 27.6059 125.944 46.3001Z'
  );
  object-fit: cover;
  background-color: $white;
}

.quote--second {
  padding-top: 48px;
  padding-bottom: 80px;
  margin-bottom: 0;

  .column:first-child {
    order: 2;
  }

  .column:nth-child(3) {
    order: 1;
  }

  img {
    margin-bottom: 24px;
  }
}

@include media-breakpoint-up(md) {
  .quote--second {
    padding-top: 112px;
    padding-bottom: 112px;

    .column {
      text-align: left;
    }

    .column:nth-child(3) {
      text-align: center;
    }

    img {
      margin-bottom: 0;
      margin-top: 16px;
      margin-right: 16px;
    }
  }
}

@include media-breakpoint-up(lg) {
  .quote--second {
    .column:nth-child(3) {
      text-align: end;
    }
  }
}
</style>
